import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import ProfileFilledSvg from "@ant-design/icons-svg/es/asn/ProfileFilled";
import AntdIcon from '../components/AntdIcon';
var ProfileFilled = function ProfileFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _objectSpread(_objectSpread({}, props), {}, {
    ref: ref,
    icon: ProfileFilledSvg
  }));
};
var RefIcon = /*#__PURE__*/React.forwardRef(ProfileFilled);
if (process.env.NODE_ENV !== 'production') {
  RefIcon.displayName = 'ProfileFilled';
}
export default RefIcon;